module.exports = __webpack_public_path__ + "b989b9b9668e876b54f7ef128be605ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/gonglue/title.png
// module id = 1115
// module chunks = 0